const { algoliasearch, instantsearch } = window;

const searchClient = algoliasearch(
  'PP0XHTY8QA',
  '543a6bd5ea3beb943b7ac9035affbc85'
);

const indexName = 'sb_inventory_items';
const querySuggestionsIndexName =
  window.ALGOLIA_QUERY_SUGGESTIONS_INDEX_NAME ||
  `${indexName}_query_suggestions`;
const DISCOVERY_ENDPOINT = '/.netlify/functions/discovery';

const search = instantsearch({
  indexName,
  searchClient,
  future: { preserveSharedStateOnUnmount: true },
});

search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox',
    placeholder: 'Search products',
  }),
  instantsearch.widgets.hits({
    container: '#hits',
    templates: {
      empty: (results, { html }) => html`
        <div class="typeahead-empty">
          <div class="typeahead-empty__title">No matching products</div>
          <div class="typeahead-empty__body">
            Try a different size, MERV rating, or filter type.
          </div>
        </div>
      `,
      item: (hit, { html, components }) => html`
        <article
          class="typeahead-product"
          data-objectid=${hit.objectID}
          data-queryid=${hit.__queryID || ''}
          data-position=${hit.__position || ''}
        >
          <div class="typeahead-product__media">
            <img src=${hit.image} alt=${hit.displayname} />
          </div>
          <div class="typeahead-product__content">
            <div class="typeahead-product__title">
              ${components.Highlight({ hit, attribute: 'displayname' })}
            </div>
          </div>
        </article>
      `,
    },
  }),
  instantsearch.widgets.configure({
    hitsPerPage: 8,
    clickAnalytics: true,
  }),
  instantsearch.widgets.pagination({
    container: '#pagination',
  }),
]);

search.start();

const QUERY_SUGGESTIONS_LIMIT = 5;

const createQuerySuggestions = () => {
  const searchArea = document.querySelector('.search-panel__results');
  const searchBox = document.querySelector('#searchbox');
  const input = searchBox?.querySelector('input[type="search"]');
  const panel = document.querySelector('#query-suggestions');
  const seeAllResults = document.querySelector('#see-all-results');

  if (!searchArea || !searchBox || !input || !panel || !seeAllResults) return;

  let latestRequestId = 0;
  let debounceTimer;
  let skipNextSuggestionsFetch = false;

  const updateSeeAllResults = (query) => {
    const trimmedQuery = query.trim();

    seeAllResults.hidden = !trimmedQuery;
    seeAllResults.textContent = trimmedQuery
      ? `See all results for "${trimmedQuery}"`
      : '';
  };

  const hidePanel = () => {
    panel.hidden = true;
    panel.innerHTML = '';
  };

  const applySuggestion = (query) => {
    const trimmedQuery = query.trim();

    if (!trimmedQuery) return;

    clearTimeout(debounceTimer);
    latestRequestId += 1;
    skipNextSuggestionsFetch = true;
    input.value = trimmedQuery;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    search.helper?.setQuery(trimmedQuery).search();
    updateSeeAllResults(trimmedQuery);
    hidePanel();
    input.focus();
  };

  seeAllResults.addEventListener('mousedown', (event) => {
    event.preventDefault();
    applySuggestion(input.value.trim());
  });

  const renderSuggestions = (suggestions) => {
    if (suggestions.length === 0) {
      hidePanel();
      return;
    }

    panel.innerHTML = '';

    const header = document.createElement('div');
    header.className = 'query-suggestions__header';
    header.textContent = 'Suggestions';
    panel.appendChild(header);

    const list = document.createElement('div');
    list.className = 'query-suggestions__list';

    suggestions.forEach((suggestion) => {
      const button = document.createElement('button');
      button.className = 'query-suggestions__item';
      button.type = 'button';
      button.textContent = suggestion.query;
      button.addEventListener('mousedown', (event) => {
        event.preventDefault();
        applySuggestion(suggestion.query);
      });
      list.appendChild(button);
    });

    panel.appendChild(list);
    panel.hidden = false;
  };

  const fetchSuggestionsFromDiscovery = async (query) => {
    const response = await fetch(DISCOVERY_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'querySuggestions',
        query,
        limit: QUERY_SUGGESTIONS_LIMIT,
      }),
    });

    if (!response.ok) {
      throw new Error('Query Suggestions endpoint failed.');
    }

    const data = await response.json();
    return (data.suggestions || [])
      .filter((suggestion) => typeof suggestion === 'string' && suggestion.trim())
      .map((suggestion) => ({
        query: suggestion,
      }));
  };

  const fetchSuggestionsFromAlgolia = async (query) => {
    const response = await searchClient.search([
      {
        indexName: querySuggestionsIndexName,
        params: {
          query,
          hitsPerPage: QUERY_SUGGESTIONS_LIMIT,
          attributesToRetrieve: ['query'],
        },
      },
    ]);

    return response.results[0].hits.filter(
      (hit) => typeof hit.query === 'string' && hit.query.trim()
    );
  };

  const fetchSuggestions = async (query) => {
    const trimmedQuery = query.trim();
    const requestId = ++latestRequestId;

    if (!trimmedQuery) {
      updateSeeAllResults('');
      hidePanel();
      return;
    }

    updateSeeAllResults(trimmedQuery);

    try {
      let suggestions = [];

      try {
        suggestions = await fetchSuggestionsFromDiscovery(trimmedQuery);
      } catch {
        suggestions = await fetchSuggestionsFromAlgolia(trimmedQuery);
      }

      if (requestId !== latestRequestId) return;

      renderSuggestions(suggestions);
    } catch {
      hidePanel();
    }
  };

  input.addEventListener('input', () => {
    if (skipNextSuggestionsFetch) {
      skipNextSuggestionsFetch = false;
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => fetchSuggestions(input.value), 120);
  });

  input.addEventListener('focus', () => {
    if (input.value.trim()) {
      fetchSuggestions(input.value);
    }
  });

  document.addEventListener('mousedown', (event) => {
    if (!searchArea.contains(event.target)) {
      hidePanel();
    }
  });
};

createQuerySuggestions();

const USER_TOKEN_STORAGE_KEY = 'algolia_user_token';
const EVENTS_ENDPOINT = '/.netlify/functions/events';

const getOrCreateAnonymousToken = () => {
  let token = window.localStorage.getItem(USER_TOKEN_STORAGE_KEY);
  if (!token) {
    token =
      window.crypto?.randomUUID?.() ||
      `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    window.localStorage.setItem(USER_TOKEN_STORAGE_KEY, token);
  }
  return token;
};

const getUserToken = () =>
  window.NETSUITE_USER_TOKEN || getOrCreateAnonymousToken();

const sendInsightsEvent = async ({
  eventType,
  eventName,
  objectIDs,
  queryID,
  positions,
  userToken = getUserToken(),
  index = indexName,
}) => {
  const payload = {
    eventType,
    eventName,
    index,
    userToken,
    objectIDs: Array.isArray(objectIDs) ? objectIDs : [objectIDs],
    queryID,
    positions,
  };

  const response = await fetch(EVENTS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }
};

const trackClick = ({ objectID, queryID, position }) =>
  sendInsightsEvent({
    eventType: 'click',
    eventName: 'Product Clicked',
    objectIDs: [objectID],
    queryID,
    positions: position ? [position] : undefined,
  });

const trackConversion = ({ objectID, queryID }) =>
  sendInsightsEvent({
    eventType: 'conversion',
    eventName: 'Product Converted',
    objectIDs: [objectID],
    queryID,
  });

window.algoliaInsights = { getUserToken, trackClick, trackConversion };

document.querySelector('#hits')?.addEventListener('click', (event) => {
  const article = event.target.closest('article[data-objectid]');
  if (!article) return;

  const objectID = article.dataset.objectid;
  const queryID = article.dataset.queryid || undefined;
  const position = Number(article.dataset.position);

  trackClick({
    objectID,
    queryID,
    position: Number.isFinite(position) ? position : undefined,
  }).catch(() => {});
});
